__turbopack_context__.v({
  "column": "BlockImageOffsetContent-module-scss-module__bby_ha__column",
  "columnContent": "BlockImageOffsetContent-module-scss-module__bby_ha__columnContent",
  "columnOffsetContent": "BlockImageOffsetContent-module-scss-module__bby_ha__columnOffsetContent",
  "columns": "BlockImageOffsetContent-module-scss-module__bby_ha__columns",
  "contentParagraph": "BlockImageOffsetContent-module-scss-module__bby_ha__contentParagraph",
  "eyebrow": "BlockImageOffsetContent-module-scss-module__bby_ha__eyebrow",
  "fade-in": "BlockImageOffsetContent-module-scss-module__bby_ha__fade-in",
  "hasTestimonial": "BlockImageOffsetContent-module-scss-module__bby_ha__hasTestimonial",
  "hasTestimonialWithoutImage": "BlockImageOffsetContent-module-scss-module__bby_ha__hasTestimonialWithoutImage",
  "imageOffsetContent": "BlockImageOffsetContent-module-scss-module__bby_ha__imageOffsetContent",
  "isInView": "BlockImageOffsetContent-module-scss-module__bby_ha__isInView",
  "noContent": "BlockImageOffsetContent-module-scss-module__bby_ha__noContent",
  "offsetLeft": "BlockImageOffsetContent-module-scss-module__bby_ha__offsetLeft",
  "whiteBackground": "BlockImageOffsetContent-module-scss-module__bby_ha__whiteBackground",
});
